module.exports = __webpack_public_path__ + "static/img/misicon1.a9ef59b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/misicon1.png
// module id = 0p6E
// module chunks = 2